import logoMark from "@/assets/logo-mark.webp";
import logoFull from "@/assets/logo-full.webp";
import icuCorridor from "@/assets/home-editorial/icu-corridor.webp";
import industryHealthcare from "@/assets/home-industries/healthcare.webp";
import industryLabs from "@/assets/home-industries/labs.webp";
import industryKitchen from "@/assets/home-industries/kitchen.webp";
import industryPharma from "@/assets/home-industries/pharma.webp";
import industryHospitality from "@/assets/home-industries/hospitality.webp";
import industryEducation from "@/assets/home-industries/pantry.webp";
import IVF from "@/assets/home-industries/ivf.webp"

export const BRAND = {
  name: "GoHealthe",
  logoUrl: logoMark,
  logoFullUrl: logoFull,
  tagline: "Architectural Hygiene, Engineered.",
  shortTagline: "Cladding Studio",
  phone: "9442638379",
  email: "Muthu@gohealthe.com",
  address:
    "Door No. 60, Jai Durga Apartments, Flat 1B\n1st Avenue, Ashok Nagar\nChennai, Tamil Nadu 600083",
};

export const NAV_LINKS = [
  // { label: "Work", to: "/industries" },
  { label: "Services", to: "/services" },
  { label: "Clients", to: "/clients" },
  // { label: "Studio", to: "/about" },
  { label: "Blog", to: "/blog" },
  { label: "Contact", to: "/contact" },
];

export const IMAGES = {
  heroBg:
    "https://images.unsplash.com/photo-1516549655169-df83a0774514?q=80&w=1600&auto=format&fit=crop",
  texture:
    "https://images.unsplash.com/photo-1533628635777-112b2239b1c7?q=80&w=1600&auto=format&fit=crop",
  hospital:
    "https://images.unsplash.com/photo-1516549655169-df83a0774514?q=80&w=1600&auto=format&fit=crop",
  hospitalCorridor: icuCorridor,
  lab:
    "https://images.unsplash.com/photo-1581093588401-fbb62a02f120?q=80&w=1600&auto=format&fit=crop",
  kitchen:
    "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?q=80&w=1600&auto=format&fit=crop",
  installer:
    "https://images.pexels.com/photos/5667685/pexels-photo-5667685.jpeg",
  architecture:
    "https://images.unsplash.com/photo-1583912267550-d97d1a5233a9?q=80&w=1600&auto=format&fit=crop",
  panel:
    "https://images.unsplash.com/photo-1587854692152-cbe660dbde88?q=80&w=1600&auto=format&fit=crop",
  pharma:
    "https://images.unsplash.com/photo-1587854692152-cbe660dbde88?q=80&w=1600&auto=format&fit=crop",
};

export const SERVICES = [
  {
    num: "01",
    title: "Antimicrobial Wall Cladding",
    detail:
      "Silver-ion infused PVC and composite wall systems that inhibit up to 99.9% of surface pathogen growth. Seamless, thermoformed corners eliminate contamination bridges.",
    tags: ["ISO 22196", "Class 1 Fire", "Non-porous"],
    slug: "antimicrobial-pvc-wall-cladding",
  },
  {
    num: "02",
    title: "Hygienic Wall Cladding",
    detail:
      "Smooth, non-porous wall protection engineered for hygiene-critical environments — seamless joints and easy-clean surfaces with no grout lines or porous finishes.",
    tags: ["Seamless", "Non-porous", "Easy-clean"],
    slug: "hygienic-wall-cladding",
  },
  {
    num: "03",
    title: "Contamination Control Flooring",
    detail:
      "Permanent entrance-zone flooring that captures and retains contaminants from footwear and wheeled equipment before they reach controlled spaces.",
    tags: ["Entrance-zone", "Reusable", "Low-maintenance"],
    slug: "contamination-control-flooring",
  },
  {
    num: "04",
    title: "Printed Glass Interiors",
    detail:
      "Custom-designed, digitally printed toughened glass wall interiors that bring branding and creativity to reception areas, lobbies and non-clinical spaces.",
    tags: ["Toughened glass", "Custom print", "PAN India"],
    slug: "printed-glass-wall",
  },
  {
    num: "05",
    title: "Hospital Refurbishment",
    detail:
      "Live-site installation methodology for operational hospitals and factories — sectional shutdown, negative-pressure containment, single-shift turnaround.",
    tags: ["Live-site", "Phased"],
    slug: "hospital-refurbishment",
  },
];

export const INDUSTRIES = [
  {
    key: "healthcare",
    label: "Healthcare",
    subtitle: "Hospitals, ICUs, operating theatres",
    image: industryHealthcare,
    copy: "From NABH-accredited hospitals to specialty OT suites, our cladding delivers the seamless, wipe-down environment infection prevention teams demand.",
  },
  {
    key: "labs",
    label: "IVF Laboratory",
    subtitle: "Embryology, andrology & cryopreservation",
    image: IVF,
    copy: "Cleanroom-grade wall and ceiling systems engineered for particulate control, air quality and the strict contamination standards IVF labs demand.",
  },
  {
    key: "kitchen",
    label: "Commercial Kitchens",
    subtitle: "Back-of-house, hood systems",
    image: industryKitchen,
    copy: "Kitchen back-of-house that inspectors love and chefs actually enjoy working in — hygienic where it counts, refined where it shows.",
  },
  {
    key: "pharma",
    label: "Pharmaceutical",
    subtitle: "GMP, sterile fill-finish, API",
    image: industryPharma,
    copy: "Monolithic wall-to-ceiling continuity for classified zones, engineered around your gowning flow, air handling and material airlocks.",
  },
  {
    key: "hospitality",
    label: "Hospitality",
    subtitle: "Hotels, spas, wellness",
    image: industryHospitality,
    copy: "Guest-facing corridors, spas and wellness spaces finished to a standard that matches five-star expectations, without compromising hygiene protocols.",
  },
  {
    key: "education",
    label: "Education & Care",
    subtitle: "Nurseries, elder care, schools",
    image: industryEducation,
    copy: "Impact-resistant, easy-clean environments for the spaces where our most vulnerable spend their days — bright, safe, and quiet to maintain.",
  },
];

export const STATS = [
  { value: "15+", label: "Years of Specialised Installation Experience" },
  { value: "5", label: "International Projects" },
  { value: "410+", label: "Projects Delivered" },
  { value: "6,48,000", label: "Sq. Ft. Installed" },
];

export const PROCESS = [
  { num: "01", label: "Site survey" },
  { num: "02", label: "Discussion & material selection" },
  { num: "03", label: "BOQ (Bill of Quantity)" },
  { num: "04", label: "Mock-up (optional 3D diagram & video)" },
  { num: "05", label: "Off-site fabrication" },
  { num: "06", label: "Phased, live-site installation" },
  { num: "07", label: "Final quality inspection before handover" },
];
